import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  toggle(event) {
    event.preventDefault()

    this.inputTarget.checked = !this.inputTarget.checked
    console.log(this.inputTarget.closest("form"));
    this.inputTarget.closest("form").submit()
  }
}
